<style scoped>
.c-panel{margin: 20px; padding: 20px;}
</style>

<template>
  <div>
    <el-dialog
        title="新增组"
        :visible.sync="dialogVisible"
        width="400px"
        top="25vh"
        :append-to-body="true"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        custom-class="full-dialog"
    >
      <el-form style="padding: 20px" ref="stuInfo" :model="json" :rules="rules" size="small" label-width="100px"
               label-position="top">
        <el-form-item label="组别名" prop="name">
          <el-input v-model="json.name" placeholder="请输入组别名" :maxlength="20" show-word-limit clearable
                    prefix-icon='el-icon-menu' :style="{width: '100%'}"></el-input>
        </el-form-item>
        <el-form-item label="学校" prop="school">
          <el-select v-model="json.school" placeholder="请择选学校" clearable :style="{width: '100%'}">
            <el-option v-for="item in schoolOptions" :key="item.id" :label="item.name"
                       :value="item.id" :disabled="item.disabled"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目" prop="subject">
          <el-select v-model="json.subject" placeholder="请选择科目" clearable :style="{width: '100%'}">
            <el-option v-for="item in subjectOptions" :key="item.id" :label="item.name"
                       :value="item.id" :disabled="item.disabled"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    inheritAttrs: false,
    components: {},
    props: [],
    data() {
      return {
        dialogVisible:false,
        json: {
          name: "",
          school: undefined,
          subject: undefined,
        },
        rules: {
          name: [{
            required: true,
            message: '请输入组别名',
            trigger: 'blur'
          }],
          school: [{
            required: true,
            message: '请择选学校',
            trigger: 'change'
          }],
          subject: [{
            required: true,
            message: '请选择科目',
            trigger: 'change'
          }],
        },
        schoolOptions: [{
          "label": "恒顺",
          "value": 1
        }, {
          "label": "苏外",
          "value": 2
        }],
        subjectOptions: [{
          "label": "C/C++",
          "value": 1
        }, {
          "label": "scratch",
          "value": 2
        }],
      }
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
      onOpen() {
        this.dialogVisible=true;
        this.getCampusList();
        this.getSubList();
      },
      close() {
        this.dialogVisible=false;
      },
      getCampusList:function (){
        this.sa.ajax('api/psdAdmin/campus/getList',
            {},
            function(res){
              this.schoolOptions = res.data;
              console.log('校区',res.data);
            }.bind(this),{async:false});
      },
      getSubList:function (){
        this.sa.ajax('api/psdAdmin/subject/getList',
            {},
            function(res){
              this.subjectOptions = res.data;
              console.log('科目',res.data);
            }.bind(this),{async:false});
      },
      handelConfirm() {
        let _this = this;
        this.$refs['stuInfo'].validate(valid => {
          if (!valid) return
        })
        console.log(this.json);
        this.sa.ajax('api/psdAdmin/des/createDesGroup',
            _this.json,
            function(res){
                if(res.code==0){
                  _this.dialogVisible=false;
                }else{
                  this.sa.error(res.msg || '创建失败');
                }
            }.bind(this));
      },
    }
  }

</script>
<style>
</style>
